<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="cancelEvent.emit()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_timer_values" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body">
    <form (submit)="$event.preventDefault()">
        <input class="form-control mb-10" type="text" [formControl]="days" />
        <input class="form-control mb-10" type="text" [formControl]="hours" />
        <input class="form-control mb-10" type="text" [formControl]="minutes" />
        <input class="form-control mb-10" type="text" [formControl]="seconds" />
    </form>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
